import React, { useEffect, useState } from "react";
import { Link as RouterLink, useHistory, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import { blue, orange } from "@material-ui/core/colors";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import Tab from "@material-ui/core/Tab";
import TabPanel from "@material-ui/lab/TabPanel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
//import MenuItem from "@mui/material/MenuItem";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import IconButton from "@mui/material/IconButton";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import { Autocomplete, createFilterOptions } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { PageLoading } from "src/components";
import {
  EvaluationPttService,
  MasService,
  VendorRegisService,
} from "src/services";
import { userStorage } from "src/common/Storage";
import AssessmentStatusLabel from "src/components/AssessmentStatusLabel/AssessmentStatusLabel";
import { saveAs } from "file-saver";
import moment from "moment";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: "3%",
    marginRight: "3%",
    marginTop: "2%",
  },
  head: {
    color: "#0009b7",
    fontWeight: "regular",
  },
  cardBack: {
    backgroundColor: blue[500],
  },
  Roundborder: {
    border: "0.5px outset #cfcfcf",
    borderRadius: "5px",
    marginTop: "1%",
    marginBottom: "2%",
    backgroundColor: "white",
  },
  textarea: {
    resize: "both",
  },
  tableContainer: {
    overflowY: "auto",
  },
  table: {
    //...
    height: "100%",
    overflowY: "scroll",
  },
  ImageIcon: {
    // marginTop: theme.spacing(3),
    width: 25,
    // [theme.breakpoints.down("md")]: {
    //   width: 30,
    // },
  },
}));

const ColorIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.getContrastText(orange[500]),
  backgroundColor: orange[500],
  "&:hover": {
    backgroundColor: orange[700],
  },
}));

const inputGrid1 = {
  vendorCode: "",
  vendorMain: "",
  vatRegistration: "",
  mainWithSubVersionId: "",
  resultCode: "",
  startDate: "",
  endtDate: "",
  commonObj: {
    lang: "th",
    currentTabNumber: "1",
    menuParameter: "",
  },
};

const inputGrid2 = {
  vendorCode: "",
  vendorMain: "",
  vatRegistration: "",
  mainWithSubVersionId: "",
  resultCode: "",
  startDate: "",
  endtDate: "",
  status: "",
  commonObj: {
    lang: "th",
    currentTabNumber: "2",
    menuParameter: "",
  },
};

function EvaluationPttScreen() {
  const { menuParameter } = useParams();
  const history = useHistory();
  const [onLoading, setOnLoading] = useState(false);
  const userInfo = userStorage.getUser();
  const userProfile = userInfo?.userProfile || {};
  const { t } = useTranslation();

  const columns = [
    { id: "id", label: "", minWidth: 50 },
    { id: "vendorCode", label: "Vendor code", minWidth: 50, align: "left" },
    { id: "vendorMain", label: <>{t("EvaluationPtt.vendorName")}</>, minWidth: 100, align: "left" },
    { id: "vatRegistration", label: <>{t("EvaluationPtt.taxNumber")}</>, minWidth: 50, align: "left", },
    { id: "resultCode", label: <>{t("EvaluationPtt.result")}</>, minWidth: 100, align: "center", },
    { id: "siteVisitScore", label: <>{t("vendorSite.score")}</>, minWidth: 75, width: 75, align: "center", format: (value) => value.toFixed(2), },
    { id: "selfAssessmentScore", label: <>{t("EvaluationSelf.seflAssScore")}</>, minWidth: 100, align: "center", format: (value) => value.toFixed(2), },
    { id: "siteVisitDate", label: <>{t("EvaluationSelf.assDate")}</>, minWidth: 100, align: "left", },
    { id: "versionName", label: <>{t("EvaluationPtt.esgVersion")}</>, minWidth: 100, align: "left", },
    { id: "createBy", label: <>{t("EvaluationSelf.recorder")}</>, minWidth: 100, align: "left", },
    { id: "createDate", label: <>{t("EvaluationSelf.transDate")}</>, minWidth: 100, align: "center", format: (value) => value.toLocaleDateString("en-US"), },
  ];
  
  const columnsTab2 = [
    { id: "id", label: "", minWidth: 50 },
    { id: "vendorCode", label: "Vendor code", minWidth: 50, align: "left" },
    { id: "vendorMain", label: <>{t("EvaluationPtt.vendorName")}</>, minWidth: 100, align: "left" },
    { id: "vatRegistration", label: <>{t("EvaluationPtt.taxNumber")}</>, minWidth: 50, align: "left", },
    { id: "status", label: <>{t("EvaluationPtt.status")}</>, minWidth: 100, align: "center", },
    { id: "resultCode", label: <>{t("EvaluationPtt.result")}</>, minWidth: 100, align: "center", },
    { id: "siteVisitScore", label: <>{t("vendorSite.score")}</>, minWidth: 75, width: 75, align: "center", format: (value) => value.toFixed(2), },
    { id: "selfAssessmentScore", label: <>{t("EvaluationSelf.seflAssScore")}</>, minWidth: 100, align: "center", format: (value) => value.toFixed(2), },
    { id: "siteVisitDate", label: <>{t("EvaluationSelf.assDate")}</>, minWidth: 100, align: "left", },
    { id: "versionName", label: <>{t("EvaluationPtt.esgVersion")}</>, minWidth: 100, align: "left", },
    { id: "createBy", label: <>{t("EvaluationSelf.recorder")}</>, minWidth: 100, align: "left", },
    { id: "createDate", label: <>{t("EvaluationSelf.transDate")}</>, minWidth: 100, align: "center", format: (value) => value.toLocaleDateString("en-US"), },
  ];
  
  const columnsTab2_SelfAssessment = [
    { id: "id", label: "", minWidth: 50 },
    { id: "vendorCode", label: "Vendor code", minWidth: 50, align: "left" },
    { id: "vendorMain", label: <>{t("EvaluationPtt.vendorName")}</>, minWidth: 100, align: "left" },
    { id: "vatRegistration", label: <>{t("EvaluationPtt.taxNumber")}</>, minWidth: 50, align: "left", },
    { id: "status", label: <>{t("EvaluationPtt.status")}</>, minWidth: 100, align: "center", },
    { id: "resultCode", label: <>{t("EvaluationPtt.result")}</>, minWidth: 100, align: "center", },
    { id: "selfAssessmentScore", label: <>{t("EvaluationSelf.seflAssScore")}</>, minWidth: 100, align: "center", format: (value) => value.toFixed(2), },
    { id: "siteVisitDate", label: <>{t("EvaluationSelf.assDate")}</>, minWidth: 100, align: "left", },
    { id: "versionName", label: <>{t("EvaluationPtt.esgVersion")}</>, minWidth: 100, align: "left", },
    { id: "createBy", label: <>{t("EvaluationSelf.recorder")}</>, minWidth: 100, align: "left", },
    { id: "createDate", label: <>{t("EvaluationSelf.transDate")}</>, minWidth: 100, align: "center", format: (value) => value.toLocaleDateString("en-US"), }, ];

  const columnsInquiryAll = [
    { id: "id", label: "", minWidth: 50 },
    { id: "vendorCode", label: "Vendor code", minWidth: 50, align: "left" },
    { id: "vendorMain", label: <>{t("EvaluationPtt.vendorName")}</>, minWidth: 100, align: "left" },
    { id: "vatRegistration", label: <>{t("EvaluationPtt.taxNumber")}</>,  minWidth: 50, align: "left", },
    { id: "summitDate", label: <>{t("EvaluationPtt.confirmDate")}</>, minWidth: 100, align: "center", format: (value) => value.toLocaleDateString("en-US"), },
    { id: "siteVisitScore", label: <>{t("EvaluationPtt.score")}</>, minWidth: 75, align: "center", format: (value) => value.toFixed(2), },
    { id: "resultCode", label: <>{t("EvaluationPtt.result")}</>, minWidth: 100, align: "center", },
    { id: "status", label: <>{t("EvaluationPtt.status")}</>, minWidth: 100, align: "center", },
    { id: "versionName", label: <>{t("EvaluationPtt.esgVersion")}</>, minWidth: 100, align: "left", },
  ];

  const gotoAssessment = (data) => {
    if (
      (data.esgType === "1" || data.esgType === "3") &&
      menuParameter === "InquiryAll"
    )
      history.push({
        pathname: "/VendorSelfAssessment",
        state: {
          vendor: data.vendorRegisID,
          main: data.mainVersionID,
          sub: data.subVersionID,
          type: "SelfAssessment_V",
        },
      });
    else if (menuParameter === "SelfAssessment")
      history.push({
        pathname: "/VendorSelfAssessment",
        state: {
          vendor: data.vendorRegisID,
          main: data.mainVersionID,
          sub: data.subVersionID,
          type: "SelfAssessment",
        },
      });
    else if (menuParameter === "SiteVisit")
      history.push({
        pathname: "/SiteVisitAssessment",
        state: {
          vendor: data.vendorRegisID,
          main: data.mainVersionID,
          sub: data.subVersionID,
          type: "SiteVisit",
        },
      });
    else if (data.esgType === "2")
      history.push({
        pathname: "/SiteVisitAssessment",
        state: {
          vendor: data.vendorRegisID,
          main: data.mainVersionID,
          sub: data.subVersionID,
          type: "InquiryAll",
        },
      });
    else history.push("/home");
  };

  const getDateWithFormat = (date) => {
    var dd = String(date.getDate()).padStart(2, "0");
    var mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = date.getFullYear();
    let dateResult = yyyy + "/" + mm + "/" + dd;
    return dateResult;
  };

  const classes = useStyles();
  const [userName, SetuserName] = useState("");
  const [evaCurrentActiveForm, setEvaCurrentActiveForm] = useState({});
  const [evalText1Tab1, SetevalText1Tab1] = useState("");
  const [evalText1Tab2, SetevalText1Tab2] = useState("");
  const [evalText2Tab1, SetevalText2Tab1] = useState("");
  const [evalText2Tab2, SetevalText2Tab2] = useState("");
  const [Datevalue1Tab1, DatesetValue1Tab1] = useState(null);
  const [Datevalue1Tab2, DatesetValue1Tab2] = useState(null);
  const [Datevalue2Tab1, DatesetValue2Tab1] = useState(null);
  const [Datevalue2Tab2, DatesetValue2Tab2] = useState(null);

  const [rowsTab1, setRowsTab1] = useState([]);
  const [rowsTab2, setRowsTab2] = useState([]);
  const [tabpage, tabpagesetValue] = useState("1");

  const [ddlVendorNameTab1, setddlVendorNameTab1] = useState([]);
  const [ddlVendorNameTab2, setddlVendorNameTab2] = useState([]);
  const [ddlVersionTab1, setddlVersionTab1] = useState([]);
  const [ddlVersionTab2, setddlVersionTab2] = useState([]);
  const [ddlEvaluationResultsTab1, setddlEvaluationResultsTab1] = useState([]);
  const [ddlEvaluationResultsTab2, setddlEvaluationResultsTab2] = useState([]);
  const [ddlStatusTab2, setddlStatusTab2] = useState([]);

  const [VendorNameTab1, setVendorNameTab1] = useState("");
  const handleChangeVendorNameTab1 = (event) => {
    setVendorNameTab1(event.target.textContent);
  };
  const [VendorNameTab2, setVendorNameTab2] = useState("");
  const handleChangeVendorNameTab2 = (event) => {
    setVendorNameTab2(event.target.textContent);
  };

  const [VersionTab1, setVersionTab1] = useState("");
  const handleChangeVersionTab1 = (event) => {
    setVersionTab1(event.target.textContent);
  };
  const [VersionTab2, setVersionTab2] = useState("");
  const handleChangeVersionTab2 = (event) => {
    setVersionTab2(event.target.textContent);
  };
  const [EvaluationResultsTab1, setEvaluationResultsTab1] = useState("");
  const handleChangeEvaluationResultsTab1 = (event) => {
    var tmp = ddlEvaluationResultsTab1.filter(
      (x) => x.label === event.target.textContent
    );
    setEvaluationResultsTab1(tmp.length > 0 ? tmp[0].value : "");
  };
  const [EvaluationResultsTab2, setEvaluationResultsTab2] = useState("");
  const handleChangeEvaluationResultsTab2 = (event) => {
    var tmp = ddlEvaluationResultsTab2.filter(
      (x) => x.label === event.target.textContent
    );
    setEvaluationResultsTab2(tmp.length > 0 ? tmp[0].value : "");
  };
  const [StatusTab2, setStatusTab2] = useState("");
  const handleChangeStatusTab2 = (event) => {
    var tmp = ddlStatusTab2.filter((x) => x.label === event.target.textContent);
    setStatusTab2(tmp.length > 0 ? tmp[0].value : "");
  };

  const tabhandleChange = (event, tabnewValue) => {
    tabpagesetValue(tabnewValue);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const editIcon = (data) => (
    <div>
      <Tooltip placement="right-start" arrow title="แก้ไขข้อมูล">
        <IconButton
          onClick={() => {
            gotoAssessment(data);
          }}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    </div>
  );

  const assignmentIcon = (data) => (
    <div>
      <Tooltip placement="right-start" arrow title="ดูแบบประเมิน">
        <IconButton
          onClick={() => {
            gotoAssessment(data);
          }}
        >
          <AssignmentIcon />
        </IconButton>
      </Tooltip>
    </div>
  );

  const resultCodeStyle = (data) => {
    let code = "";
    let desc = "";

    if (data.resultCode === "Pass" || data.resultCode === "ผ่าน") {
      code = "P";
      desc = data.resultCode;
    } else if (
      data.resultCode === "Not Pass" ||
      data.resultCode === "ไม่ผ่าน"
    ) {
      code = "N";
      desc = data.resultCode;
    }
    return <AssessmentStatusLabel statusCode={code} cursor={"default"} />;
  };

  const statusStyle = (data) =>
    data.code === "A" ? (
      <Tooltip placement="top" arrow title={data.tooltipDesc}>
        <Box
          sx={{ color: data.textColor, fontWeight: "bold", cursor: "pointer" }}
        >
          {data.name}
        </Box>
      </Tooltip>
    ) : data.code === "D" ? (
      <Tooltip placement="top" arrow title={data.tooltipDesc}>
        <Box
          sx={{ color: data.textColor, fontWeight: "bold", cursor: "pointer" }}
        >
          {data.name}
        </Box>
      </Tooltip>
    ) : data.code === "I" ? (
      <Tooltip placement="top" arrow title={data.tooltipDesc}>
        <Box
          sx={{ color: data.textColor, fontWeight: "bold", cursor: "pointer" }}
        >
          {data.name}
        </Box>
      </Tooltip>
    ) : data.code === "R" ? (
      <Tooltip placement="top" arrow title={data.tooltipDesc}>
        <Box
          sx={{ color: data.textColor, fontWeight: "bold", cursor: "pointer" }}
        >
          {data.name}
        </Box>
      </Tooltip>
    ) : (
      ""
    );

  const SearchGrid1 = () => {
    setOnLoading(true);

    inputGrid1.vendorCode =
      evalText1Tab1 === "--- ทั้งหมด ---" ? "" : evalText1Tab1;
    inputGrid1.vendorMain =
      VendorNameTab1 === "--- ทั้งหมด ---" ? "" : VendorNameTab1;
    inputGrid1.vatRegistration =
      evalText2Tab1 === "--- ทั้งหมด ---" ? "" : evalText2Tab1;
    inputGrid1.mainWithSubVersionId =
      VersionTab1 === "--- ทั้งหมด ---" ? "" : VersionTab1;
    inputGrid1.resultCode =
      EvaluationResultsTab1 === "--- ทั้งหมด ---" ? "" : EvaluationResultsTab1;
    inputGrid1.startDate =
      Datevalue1Tab1 === "--- ทั้งหมด ---" ? "" : Datevalue1Tab1;
    inputGrid1.endtDate =
      Datevalue2Tab1 === "--- ทั้งหมด ---" ? "" : Datevalue2Tab1;
    inputGrid1.commonObj.lang = "th";
    inputGrid1.commonObj.menuParameter = menuParameter;

    inputGrid1.UserName = userName;

    EvaluationPttService.GridPttData(inputGrid1).then((resp) => {
      setRowsTab1(resp);
      setOnLoading(false);
    });
  };

  const SearchGrid2 = () => {
    setOnLoading(true);

    inputGrid2.vendorCode =
      evalText1Tab2 === "--- ทั้งหมด ---" ? "" : evalText1Tab2;
    inputGrid2.vendorMain =
      VendorNameTab2 === "--- ทั้งหมด ---" ? "" : VendorNameTab2;
    inputGrid2.vatRegistration =
      evalText2Tab2 === "--- ทั้งหมด ---" ? "" : evalText2Tab2;
    inputGrid2.mainWithSubVersionId =
      VersionTab2 === "--- ทั้งหมด ---" ? "" : VersionTab2;
    inputGrid2.resultCode =
      EvaluationResultsTab2 === "--- ทั้งหมด ---" ? "" : EvaluationResultsTab2;
    inputGrid2.startDate =
      Datevalue1Tab2 === "--- ทั้งหมด ---" ? "" : Datevalue1Tab2;
    inputGrid2.endtDate =
      Datevalue2Tab2 === "--- ทั้งหมด ---" ? "" : Datevalue2Tab2;
    inputGrid2.status = StatusTab2 === "--- ทั้งหมด ---" ? "" : StatusTab2;
    inputGrid2.commonObj.lang = "th";
    inputGrid2.commonObj.menuParameter = menuParameter;

    if (menuParameter === "InquiryAll")
      inputGrid2.commonObj.currentTabNumber = "";
    else {
      inputGrid2.commonObj.currentTabNumber = "2";
      inputGrid1.UserName = userName;
    }

    EvaluationPttService.GridPttData(inputGrid2).then((resp) => {
      setRowsTab2(resp);
      setOnLoading(false);
    });
  };

  useEffect(() => {
    setOnLoading(true);

    EvaluationPttService.ddlVendorName().then((resp) => {
      var tmp = [{ value: "--- ทั้งหมด ---", label: "--- ทั้งหมด ---" }];
      for (var i = 0; i < resp.length; i++) {
        tmp.push(resp[i]);
      }
      setddlVendorNameTab1(tmp);
      setddlVendorNameTab2(tmp);
    });

    MasService.GetEvaluationVersionByStatusForm(2).then((resp) => {
      var tmp = [{ value: "--- ทั้งหมด ---", label: "--- ทั้งหมด ---" }];
      for (var i = 0; i < resp.data.length; i++) {
        tmp.push(resp.data[i]);
      }
      setddlVersionTab1(tmp);
      setddlVersionTab2(tmp);
    });

    EvaluationPttService.ddlEvaluationResults().then((resp) => {
      var tmp = [{ value: "--- ทั้งหมด ---", label: "--- ทั้งหมด ---" }];
      for (var i = 0; i < resp.length; i++) {
        tmp.push(resp[i]);
      }
      setddlEvaluationResultsTab1(tmp);
      setddlEvaluationResultsTab2(tmp);
    });

    EvaluationPttService.ddlStatus(inputGrid2.commonObj).then((resp) => {
      var tmp = [{ value: "--- ทั้งหมด ---", label: "--- ทั้งหมด ---" }];
      for (var i = 0; i < resp.length; i++) {
        tmp.push(resp[i]);
      }
      setddlStatusTab2(tmp);
    });

    if (menuParameter === "InquiryAll") {
      var date = new Date();
      var firstDay = getDateWithFormat(
        new Date(date.getFullYear(), date.getMonth(), 1)
      );
      var lastDay = getDateWithFormat(
        new Date(date.getFullYear(), date.getMonth() + 1, 0)
      );

      DatesetValue1Tab2(firstDay);
      DatesetValue2Tab2(lastDay);
      inputGrid2.startDate = firstDay;
      inputGrid2.endtDate = lastDay;
      inputGrid2.commonObj.menuParameter = "InquiryAll";
      inputGrid2.mainWithSubVersionId = "";
      inputGrid2.resultCode = "";
      inputGrid2.status = "A";
      inputGrid2.vatRegistration = "";
      inputGrid2.vendorCode = "";
      inputGrid2.vendorMain = "";
      EvaluationPttService.GridPttData(inputGrid2).then((resp) => {
        setRowsTab2(resp);
        setOnLoading(false);
      });
    } else {
      SetuserName(userProfile.userName);

      inputGrid1.commonObj.currentTabNumber = "1";
      inputGrid1.commonObj.lang = "th";
      inputGrid1.commonObj.menuParameter = menuParameter;
      inputGrid1.UserName = userProfile.userName;
      console.log("Body 1 :", inputGrid1);
      EvaluationPttService.GridPttData(inputGrid1).then((resp) => {
        setRowsTab1(resp);
      });

      inputGrid2.commonObj.currentTabNumber = "2";
      inputGrid2.commonObj.lang = "th";
      inputGrid2.commonObj.menuParameter = menuParameter;
      inputGrid2.UserName = userProfile.userName;
      console.log("Body 2 :", inputGrid2);
      EvaluationPttService.GridPttData(inputGrid2).then((resp) => {
        setRowsTab2(resp);
        setOnLoading(false);
      });
    }

    VendorRegisService.getCurrentForm().then((resp) => {
      setEvaCurrentActiveForm(resp);
    });

    setOnLoading(true);
  }, []);

  const ExcalBtn = (a) => {
    if (rowsTab2.length > 0) {
      setOnLoading(true);
      inputGrid2.vendorCode =
        evalText1Tab2 === "--- ทั้งหมด ---" ? "" : evalText1Tab2;
      inputGrid2.vendorMain =
        VendorNameTab2 === "--- ทั้งหมด ---" ? "" : VendorNameTab2;
      inputGrid2.vatRegistration =
        evalText2Tab2 === "--- ทั้งหมด ---" ? "" : evalText2Tab2;
      inputGrid2.mainWithSubVersionId =
        VersionTab2 === "--- ทั้งหมด ---" ? "" : VersionTab2;
      inputGrid2.resultCode =
        EvaluationResultsTab2 === "--- ทั้งหมด ---"
          ? ""
          : EvaluationResultsTab2;
      inputGrid2.startDate =
        Datevalue1Tab2 === "--- ทั้งหมด ---" ? "" : Datevalue1Tab2;
      inputGrid2.endtDate =
        Datevalue2Tab2 === "--- ทั้งหมด ---" ? "" : Datevalue2Tab2;
      inputGrid2.status = StatusTab2 === "--- ทั้งหมด ---" ? "" : StatusTab2;
      inputGrid2.commonObj.lang = "th";
      inputGrid2.commonObj.menuParameter = menuParameter;

      if (menuParameter === "InquiryAll")
        inputGrid2.commonObj.currentTabNumber = "";
      else {
        inputGrid2.commonObj.currentTabNumber = "2";
        inputGrid1.UserName = userName;
      }

      EvaluationPttService.GetPttFormExcelExport(inputGrid2)
        .then((data) => {
          saveAs(
            data,
            "EvaluationResult_" + moment().format("YYYYMMDDHHmmss") + ".xlsx"
          );
        })
        .then(() => setOnLoading(false));
    }
  };

  return (
    <div className={classes.root}>
      <PageLoading open={onLoading} />
      <div className={classes.head}>
        <Grid
          columns={16}
          container
          direction="row"
          justifyContent="space-between"
          alignContent="center"
          alignItems="center"
        >
          <Grid item xs={14}>
            <h1>
              {menuParameter === "InquiryAll"
                ? t("EvaluationPtt.headerLabel")
                : menuParameter === "SiteVisit"
                  ? t("vendorSite.headerLabel")
                  : t("EvaluationSelf.headerLabel")}
            </h1>
          </Grid>
          <Grid item xs={2} style={{ flexGrow: "1" }}>
            {menuParameter !== "InquiryAll" ? (
              <Stack direction="row" spacing={4}>
                <Button
                  sx={{
                    color: "white",
                    padding: "5px",
                    boxShadow: 3,
                    margin: "5px",
                  }}
                  onClick={() => {
                    gotoAssessment({
                      vendorRegisID: 0,
                      mainVersionID: evaCurrentActiveForm.mainVersionID,
                      subVersionID: evaCurrentActiveForm.subVersionID,
                    });
                  }}
                  variant="outlined"
                  // startIcon={}
                  style={{
                    flexGrow: "1",
                    backgroundColor: "#0FBEF5",
                    border: "2px solid #0FBEF5",
                    borderRadius: "5px",
                    borderColor: "#0FBEF5",
                  }}
                >
                  {/* <AssignmentIcon sx={{ fontSize: 70 }}  /> */}

                  <Stack direction="row" spacing={2}>
                    <Stack justifyContent="center">
                      <img
                        // className={classes.ImageIcon}
                        sx={{ width: 25 }}
                        alt="Logo"
                        src="/images/doc_create_esg.png"
                      />
                    </Stack>

                    <Stack direction="column">
                      <Stack
                        sx={{
                          marginLeft: "10px",
                          marginTop: "4px",
                          boxShadow: 3,
                          backgroundColor: "#053BFB",
                          border: "5px solid #053BFB",
                          borderRadius: "5px 5px",
                          fontWeight: "bold",
                        }}
                      >
                        {t("vendorSite.btnSave")}
                      </Stack>
                    </Stack>
                  </Stack>
                </Button>
              </Stack>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </div>

      {menuParameter === "InquiryAll" ? (
        <Box className={classes.Roundborder} sx={{ width: "100%" }}>
          <Box sx={{ margin: "20px", backgroundColor: "white" }}>
            <Grid
              container
              style={{ fontWeight: "bold" }}
              direction="row"
              justifyContent="left"
            >
              {t("EvaluationPtt.assList")}
            </Grid>
            <br />
            <Grid
              container
              rowSpacing={2}
              spacing={1}
              columns={16}
              direction="row"
              alignContent="center"
              justifyContent="left"
            >
              <Grid item xs={3}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    size="small"
                    style={{ backgroundColor: "white" }}
                    fullWidth
                    id="txtVendorCodeTab2"
                    label="Vendor code"
                    type="search"
                    onChange={(e) => SetevalText1Tab2(e.target.value)}
                  ></TextField>
                </FormControl>
              </Grid>
              <Grid item xs={7}>
                <FormControl sx={{ width: "100%" }}>
                  <Autocomplete
                    id="ddlVendorNameTab2"
                    size="small"
                    options={ddlVendorNameTab2}
                    filterOptions={createFilterOptions({
                      limit: 20,
                    })}
                    value={
                      ddlVendorNameTab2.filter(
                        (x) => x.label === VendorNameTab2
                      ).length > 0
                        ? ddlVendorNameTab2.filter(
                          (x) => x.label === VendorNameTab2
                        )[0]
                        : ""
                    }
                    renderInput={(params) => (
                      <TextField size="small" {...params} label={t("EvaluationPtt.vendorName")} />
                    )}
                    onChange={(event) => {
                      handleChangeVendorNameTab2(event);
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={5}>
                <TextField
                  size="small"
                  onChange={(e) => SetevalText2Tab2(e.target.value)}
                  style={{ backgroundColor: "white" }}
                  fullWidth
                  id="txtVatRegisTab2"
                  label={t("EvaluationPtt.taxNumber")}
                  type="search"
                  inputProps={{ className: classes.textarea }}
                />
              </Grid>
              <Grid item xs={1}>
                <ColorIconButton
                  sx={{ color: "#ffa489", backgroundColor: "#FFA489" }}
                  size="small"
                  onClick={() => SearchGrid2()}
                >
                  <SearchRoundedIcon sx={{ color: "white" }} />
                </ColorIconButton>
              </Grid>
              <Grid item xs={10}>
                <FormControl sx={{ width: "100%" }}>
                  <Autocomplete
                    id="txtVerionTab2"
                    size="small"
                    options={ddlVersionTab2}
                    filterOptions={createFilterOptions({
                      limit: 20,
                    })}
                    value={
                      ddlVersionTab2.filter((x) => x.label === VersionTab2)
                        .length > 0
                        ? ddlVersionTab2.filter(
                          (x) => x.label === VersionTab2
                        )[0]
                        : ""
                    }
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        {...params}
                        label={t("EvaluationPtt.assVersion")}
                      />
                    )}
                    onChange={(event) => {
                      handleChangeVersionTab2(event);
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <FormControl sx={{ width: "100%" }}>
                  <Autocomplete
                    id="ddlEvaluationResultsTab2"
                    size="small"
                    options={ddlEvaluationResultsTab2}
                    filterOptions={createFilterOptions({
                      limit: 20,
                    })}
                    value={
                      ddlEvaluationResultsTab2.filter(
                        (x) => x.value === EvaluationResultsTab2
                      ).length > 0
                        ? ddlEvaluationResultsTab2.filter(
                          (x) => x.value === EvaluationResultsTab2
                        )[0]
                        : ""
                    }
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        {...params}
                        label={t("EvaluationPtt.result")}
                      />
                    )}
                    onChange={(event) => {
                      handleChangeEvaluationResultsTab2(event);
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <FormControl sx={{ width: "100%" }}>
                  <Autocomplete
                    id="ddlStatusTab2"
                    size="small"
                    options={ddlStatusTab2}
                    filterOptions={createFilterOptions({
                      limit: 20,
                    })}
                    value={
                      ddlStatusTab2.filter((x) => x.value === StatusTab2)
                        .length > 0
                        ? ddlStatusTab2.filter((x) => x.value === StatusTab2)[0]
                        : ""
                    }
                    renderInput={(params) => (
                      <TextField size="small" {...params} label={t("EvaluationPtt.status")} />
                    )}
                    onChange={(event) => {
                      handleChangeStatusTab2(event);
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <FormControl sx={{ width: "100%" }}>
                    <DesktopDatePicker
                      views={["year", "month", "day"]}
                      label={t("EvaluationPtt.fromDate")}
                      inputFormat="dd/MM/yyyy"
                      value={Datevalue1Tab2}
                      // onChange={handleChange}
                      onChange={(newValue) => DatesetValue1Tab2(newValue)}
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                    />
                  </FormControl>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <FormControl sx={{ width: "100%" }}>
                    <DesktopDatePicker
                      views={["year", "month", "day"]}
                      label={t("EvaluationPtt.toDate")}
                      inputFormat="dd/MM/yyyy"
                      value={Datevalue2Tab2}
                      // onChange={handleChange}
                      onChange={(newValue) => DatesetValue2Tab2(newValue)}
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                    />
                  </FormControl>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={8} style={{ textAlign: "right" }}>
                <Button
                  style={{
                    color: "#fff",
                    backgroundColor: "#1D6F42",
                    textTransform: "none",
                  }}
                  size="medium"
                  onClick={() => ExcalBtn()}
                >
                  <img
                    className={classes.ImageIcon}
                    alt="Logo"
                    src="/images/excel.png"
                  />
                  &nbsp; Export Excel
                </Button>
              </Grid>
            </Grid>
            <br />
            <Grid
              container
              rowSpacing={2}
              spacing={1}
              columns={16}
              direction="row"
              alignContent="center"
              justifyContent="left"
            >
              <Grid item xs={16}>
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer className={classes.tableContainer}>
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      className={classes.table}
                    >
                      <TableHead>
                        <TableRow>
                          {columnsInquiryAll.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                width: column.width,
                                minWidth: column.minWidth,
                                fontWeight: "bold",
                                fontSize: "1rem",
                                backgroundColor: "#8ae3ff",
                                color: "#00358a",
                              }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rowsTab2.length > 0 ? (
                          rowsTab2
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row, i) => {
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={i}
                                >
                                  {columnsInquiryAll.map((column) => {
                                    const value = row[column.id];
                                    return (
                                      <TableCell
                                        key={column.id}
                                        align={column.align}
                                      >
                                        {column.format &&
                                          typeof value === "number"
                                          ? column.id === "id"
                                            ? assignmentIcon(value)
                                            : column.format(value)
                                          : column.id === "id"
                                            ? // ? 1 === 1
                                            //   ? editIcon(value)
                                            //   : assignmentIcon(value)
                                            assignmentIcon(row)
                                            : column.id === "resultCode"
                                              ? resultCodeStyle(row)
                                              : column.id === "status"
                                                ? statusStyle(value)
                                                : value}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              );
                            })
                        ) : (
                          <TableRow>
                            <TableCell colSpan={7}>
                              <Grid
                                container
                                style={{ fontWeight: "bold" }}
                                direction="row"
                                justifyContent="center"
                              >
                                {t("VendorRegis.dataNotFound")}
                              </Grid>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[25, 50, 75, 100]}
                    component="div"
                    count={rowsTab2.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Box>
      ) : (
        <Box sx={{ width: "100%" }}>
          <TabContext value={tabpage}>
            <Box
              sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}
            >
              <TabList onChange={tabhandleChange}>
                <Tab label={t("EvaluationSelf.tab1")} value="1"></Tab>
                <Tab label={t("EvaluationSelf.tab2")} value="2"></Tab>
              </TabList>
            </Box>

            <TabPanel value="1" className={classes.Roundborder}>
              <Grid
                container
                style={{ fontWeight: "bold" }}
                direction="row"
                justifyContent="left"
              >
                {t("EvaluationSelf.tab1")}
              </Grid>
              <br />
              <Grid
                container
                rowSpacing={2}
                spacing={1}
                columns={16}
                direction="row"
                alignContent="center"
                justifyContent="left"
              >
                <Grid item xs={3}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      size="small"
                      style={{ backgroundColor: "white" }}
                      fullWidth
                      id="txtVendorCodeTab1"
                      label="Vendor code"
                      type="search"
                      onChange={(e) => SetevalText1Tab1(e.target.value)}
                    ></TextField>
                  </FormControl>
                </Grid>
                <Grid item xs={8}>
                  <FormControl sx={{ width: "100%" }}>
                    <Autocomplete
                      id="ddlVendorNameTab1"
                      size="small"
                      options={ddlVendorNameTab1}
                      filterOptions={createFilterOptions({
                        limit: 20,
                      })}
                      value={
                        ddlVendorNameTab1.filter(
                          (x) => x.label === VendorNameTab1
                        ).length > 0
                          ? ddlVendorNameTab1.filter(
                            (x) => x.label === VendorNameTab1
                          )[0]
                          : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          {...params}
                          label={t("EvaluationPtt.vendorName")}
                        />
                      )}
                      onChange={(event) => {
                        handleChangeVendorNameTab1(event);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    onChange={(e) => SetevalText2Tab1(e.target.value)}
                    style={{ backgroundColor: "white" }}
                    fullWidth
                    id="txtVatRegisTab1"
                    label={t("EvaluationPtt.taxNumber")}
                    type="search"
                    inputProps={{ className: classes.textarea }}
                  />
                </Grid>
                <Grid item xs={1}>
                  <ColorIconButton
                    sx={{ color: "#ffa489", backgroundColor: "#FFA489" }}
                    size="small"
                    onClick={() => SearchGrid1()}
                  >
                    <SearchRoundedIcon sx={{ color: "white" }} />
                  </ColorIconButton>
                </Grid>
                <Grid item xs={11}>
                  <FormControl sx={{ width: "100%" }}>
                    <Autocomplete
                      id="txtVerionTab1"
                      size="small"
                      options={ddlVersionTab1}
                      filterOptions={createFilterOptions({
                        limit: 20,
                      })}
                      value={
                        ddlVersionTab1.filter((x) => x.label === VersionTab1)
                          .length > 0
                          ? ddlVersionTab1.filter(
                            (x) => x.label === VersionTab1
                          )[0]
                          : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          {...params}
                          label={t("EvaluationPtt.esgVersion")}
                        />
                      )}
                      onChange={(event) => {
                        handleChangeVersionTab1(event);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControl sx={{ width: "100%" }}>
                    <Autocomplete
                      id="ddlEvaluationResultsTab1"
                      size="small"
                      options={ddlEvaluationResultsTab1}
                      filterOptions={createFilterOptions({
                        limit: 20,
                      })}
                      value={
                        ddlEvaluationResultsTab1.filter(
                          (x) => x.value === EvaluationResultsTab1
                        ).length > 0
                          ? ddlEvaluationResultsTab1.filter(
                            (x) => x.value === EvaluationResultsTab1
                          )[0]
                          : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          {...params}
                          label={t("EvaluationPtt.result")}
                        />
                      )}
                      onChange={(event) => {
                        handleChangeEvaluationResultsTab1(event);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={4}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <FormControl sx={{ width: "100%" }}>
                      <DesktopDatePicker
                        views={["year", "month", "day"]}
                        label={t("EvaluationSelf.fromDate")}
                        inputFormat="dd/MM/yyyy"
                        value={Datevalue1Tab1}
                        // onChange={handleChange}
                        onChange={(newValue) => DatesetValue1Tab1(newValue)}
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </FormControl>
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <FormControl sx={{ width: "100%" }}>
                      <DesktopDatePicker
                        views={["year", "month", "day"]}
                        label={t("EvaluationSelf.toDate")}
                        inputFormat="dd/MM/yyyy"
                        value={Datevalue2Tab1}
                        // onChange={handleChange}
                        onChange={(newValue) => DatesetValue2Tab1(newValue)}
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </FormControl>
                  </LocalizationProvider>
                </Grid>
              </Grid>
              <br />
              <Grid
                container
                rowSpacing={2}
                spacing={1}
                columns={16}
                direction="row"
                alignContent="center"
                justifyContent="left"
              >
                <Grid item xs={16}>
                  <Paper sx={{ width: "100%", overflow: "hidden" }}>
                    <TableContainer className={classes.tableContainer}>
                      <Table
                        stickyHeader
                        aria-label="sticky table"
                        className={classes.table}
                      >
                        <TableHead>
                          <TableRow>
                            {columns.map((column) => {
                              if (
                                menuParameter === "SelfAssessment" &&
                                (column.id === "siteVisitScore" ||
                                  column.id === "siteVisitDate")
                              ) {
                                return null;
                              }

                              return (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  style={{
                                    width: column.width,
                                    minWidth: column.minWidth,
                                    fontWeight: "bold",
                                    fontSize: "1rem",
                                    backgroundColor: "#8ae3ff",
                                    color: "#00358a",
                                  }}
                                >
                                  {column.label}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsTab1.length > 0 ? (
                            rowsTab1
                              .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                              .map((row, i) => {
                                return (
                                  <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={i}
                                  >
                                    {columns.map((column) => {
                                      const value = row[column.id];

                                      if (
                                        menuParameter === "SelfAssessment" &&
                                        (column.id === "siteVisitScore" ||
                                          column.id === "siteVisitDate")
                                      ) {
                                        return null;
                                      }

                                      return (
                                        <TableCell
                                          key={column.id}
                                          align={column.align}
                                        >
                                          {column.format &&
                                            typeof value === "number"
                                            ? column.id === "id"
                                              ? assignmentIcon(value)
                                              : column.format(value)
                                            : column.id === "id"
                                              ? editIcon(row)
                                              : column.id === "resultCode"
                                                ? resultCodeStyle(row)
                                                : column.id === "status"
                                                  ? statusStyle(value)
                                                  : column.format
                                                    ? column.id === "selfAssessmentScore" ? value !== null ? value : '-' : value
                                                    : value}
                                        </TableCell>
                                      );
                                    })}
                                  </TableRow>
                                );
                              })
                          ) : (
                            <TableRow>
                              <TableCell colSpan={7}>
                                <Grid
                                  container
                                  style={{ fontWeight: "bold" }}
                                  direction="row"
                                  justifyContent="center"
                                >
                                  {t("VendorRegis.dataNotFound")}
                                </Grid>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[25, 50, 75, 100]}
                      component="div"
                      count={rowsTab1.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Paper>
                </Grid>
              </Grid>
            </TabPanel>

            <TabPanel value="2" className={classes.Roundborder}>
              <Grid
                container
                style={{ fontWeight: "bold" }}
                direction="row"
                justifyContent="left"
              >
                {t("EvaluationSelf.tab2")}
              </Grid>
              <br />
              <Grid
                container
                rowSpacing={2}
                spacing={1}
                columns={16}
                direction="row"
                alignContent="center"
                justifyContent="left"
              >
                <Grid item xs={3}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      size="small"
                      style={{ backgroundColor: "white" }}
                      fullWidth
                      id="txtVendorCodeTab2"
                      label="Vendor code"
                      type="search"
                      onChange={(e) => SetevalText1Tab2(e.target.value)}
                    ></TextField>
                  </FormControl>
                </Grid>
                <Grid item xs={7}>
                  <FormControl sx={{ width: "100%" }}>
                    <Autocomplete
                      id="ddlVendorNameTab2"
                      size="small"
                      options={ddlVendorNameTab2}
                      filterOptions={createFilterOptions({
                        limit: 20,
                      })}
                      value={
                        ddlVendorNameTab2.filter(
                          (x) => x.label === VendorNameTab2
                        ).length > 0
                          ? ddlVendorNameTab2.filter(
                            (x) => x.label === VendorNameTab2
                          )[0]
                          : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          {...params}
                          label={t("EvaluationPtt.vendorName")}
                        />
                      )}
                      onChange={(event) => {
                        handleChangeVendorNameTab2(event);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    size="small"
                    onChange={(e) => SetevalText2Tab2(e.target.value)}
                    style={{ backgroundColor: "white" }}
                    fullWidth
                    id="txtVatRegisTab2"
                    label={t("EvaluationPtt.taxNumber")}
                    type="search"
                    inputProps={{ className: classes.textarea }}
                  />
                </Grid>
                <Grid item xs={1}>
                  <ColorIconButton
                    sx={{ color: "#ffa489", backgroundColor: "#FFA489" }}
                    size="small"
                    onClick={() => SearchGrid2()}
                  >
                    <SearchRoundedIcon sx={{ color: "white" }} />
                  </ColorIconButton>
                </Grid>
                <Grid item xs={10}>
                  <FormControl sx={{ width: "100%" }}>
                    <Autocomplete
                      id="txtVerionTab2"
                      size="small"
                      options={ddlVersionTab2}
                      filterOptions={createFilterOptions({
                        limit: 20,
                      })}
                      value={
                        ddlVersionTab2.filter((x) => x.label === VersionTab2)
                          .length > 0
                          ? ddlVersionTab2.filter(
                            (x) => x.label === VersionTab2
                          )[0]
                          : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          {...params}
                          label={t("EvaluationPtt.esgVersion")}
                        />
                      )}
                      onChange={(event) => {
                        handleChangeVersionTab2(event);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControl sx={{ width: "100%" }}>
                    <Autocomplete
                      id="ddlEvaluationResultsTab2"
                      size="small"
                      options={ddlEvaluationResultsTab2}
                      filterOptions={createFilterOptions({
                        limit: 20,
                      })}
                      value={
                        ddlEvaluationResultsTab2.filter(
                          (x) => x.value === EvaluationResultsTab2
                        ).length > 0
                          ? ddlEvaluationResultsTab2.filter(
                            (x) => x.value === EvaluationResultsTab2
                          )[0]
                          : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          {...params}
                          label={t("EvaluationPtt.result")}
                        />
                      )}
                      onChange={(event) => {
                        handleChangeEvaluationResultsTab2(event);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl sx={{ width: "100%" }}>
                    <Autocomplete
                      id="ddlStatusTab2"
                      size="small"
                      options={ddlStatusTab2}
                      filterOptions={createFilterOptions({
                        limit: 20,
                      })}
                      value={
                        ddlStatusTab2.filter((x) => x.value === StatusTab2)
                          .length > 0
                          ? ddlStatusTab2.filter(
                            (x) => x.value === StatusTab2
                          )[0]
                          : ""
                      }
                      renderInput={(params) => (
                        <TextField size="small" {...params} label={t("EvaluationPtt.status")} />
                      )}
                      onChange={(event) => {
                        handleChangeStatusTab2(event);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={4}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <FormControl sx={{ width: "100%" }}>
                      <DesktopDatePicker
                        views={["year", "month", "day"]}
                        label={t("EvaluationSelf.fromDate")}
                        inputFormat="dd/MM/yyyy"
                        value={Datevalue1Tab2}
                        // onChange={handleChange}
                        onChange={(newValue) => DatesetValue1Tab2(newValue)}
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </FormControl>
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <FormControl sx={{ width: "100%" }}>
                      <DesktopDatePicker
                        views={["year", "month", "day"]}
                        label={t("EvaluationSelf.toDate")}
                        inputFormat="dd/MM/yyyy"
                        value={Datevalue2Tab2}
                        // onChange={handleChange}
                        onChange={(newValue) => DatesetValue2Tab2(newValue)}
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </FormControl>
                  </LocalizationProvider>
                </Grid>
              </Grid>
              <br />
              <Grid
                container
                rowSpacing={2}
                spacing={1}
                columns={16}
                direction="row"
                alignContent="center"
                justifyContent="left"
              >
                <Grid item xs={16}>
                  <Paper sx={{ width: "100%", overflow: "hidden" }}>
                    <TableContainer className={classes.tableContainer}>
                      <Table
                        stickyHeader
                        aria-label="sticky table"
                        className={classes.table}
                      >
                        <TableHead>
                          <TableRow>
                            {menuParameter !== 'SelfAssessment' ? columnsTab2.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  width: column.width,
                                  minWidth: column.minWidth,
                                  fontWeight: "bold",
                                  fontSize: "1rem",
                                  backgroundColor: "#8ae3ff",
                                  color: "#00358a",
                                }}
                              >
                                {column.label}
                              </TableCell>
                            )) : columnsTab2_SelfAssessment.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  width: column.width,
                                  minWidth: column.minWidth,
                                  fontWeight: "bold",
                                  fontSize: "1rem",
                                  backgroundColor: "#8ae3ff",
                                  color: "#00358a",
                                }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsTab2.length > 0 ? (
                            rowsTab2
                              .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                              .map((row, i) => {
                                return (
                                  <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={i}
                                  >
                                    {menuParameter !== 'SelfAssessment' ? columnsTab2.map((column) => {
                                      const value = row[column.id];
                                      return (
                                        <TableCell
                                          key={column.id}
                                          align={column.align}
                                        >
                                          {column.format &&
                                            typeof value === "number"
                                            ? column.id === "id"
                                              ? assignmentIcon(value)
                                              : column.format(value)
                                            : column.id === "id"
                                              ? assignmentIcon(row)
                                              : column.id === "resultCode"
                                                ? resultCodeStyle(row)
                                                : column.id === "status"
                                                  ? statusStyle(value)
                                                  : column.format
                                                    ? column.id === "selfAssessmentScore" ? value !== null ? value : '-' : value
                                                    : value}
                                        </TableCell>
                                      );
                                    }) : columnsTab2_SelfAssessment.map((column) => {
                                      const value = row[column.id];
                                      return (
                                        <TableCell
                                          key={column.id}
                                          align={column.align}
                                        >
                                          {column.format &&
                                            typeof value === "number"
                                            ? column.id === "id"
                                              ? assignmentIcon(value)
                                              : column.format(value)
                                            : column.id === "id"
                                              ? assignmentIcon(row)
                                              : column.id === "resultCode"
                                                ? resultCodeStyle(row)
                                                : column.id === "status"
                                                  ? statusStyle(value)
                                                  : column.format
                                                    ? column.id === "selfAssessmentScore" ? value !== null ? value : '-' : value
                                                    : value}
                                        </TableCell>
                                      );
                                    })}
                                  </TableRow>
                                );
                              })
                          ) : (
                            <TableRow>
                              <TableCell colSpan={7}>
                                <Grid
                                  container
                                  style={{ fontWeight: "bold" }}
                                  direction="row"
                                  justifyContent="center"
                                >
                                  {t("VendorRegis.dataNotFound")}
                                </Grid>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[25, 50, 75, 100]}
                      component="div"
                      count={rowsTab2.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Paper>
                </Grid>
              </Grid>
            </TabPanel>
          </TabContext>
        </Box>
      )}
    </div>
  );
}

export default EvaluationPttScreen;
